import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from '../constants/dates';

export const getFormattedDate = (date: string, format: string = DEFAULT_DATE_FORMAT): string =>
  moment.utc(date).local().format(format);
